<template>
    <div class="c-benefits-slideshow">
        <y-slideshow
            ref="Slideshow"
            pagination="1"
            looped-slides="1"
            :other-options="slideshowOptions || options"
            data-aos="zoom-in"
            data-aos-duration="1000"
            autoplay
            height="auto"
        >
            <y-slide
                v-for="(album, index) in content.albums.filter(i=> i.group === 'album')"
                :key="`responsive-benefits-${index}`"
            >
                <div class="c-benefits-slideshow__card">
                    <div class="card-img-container">
                        <img
                            :src="album.link"
                            :alt="album.title"
                            class="card-img"
                        >
                    </div>

                    <div class="card-title">
                        <h3>
                            {{ album.title }}
                        </h3>
                    </div>
                    <div class="card-description">
                        <p>
                            {{ album.description }}
                        </p>
                    </div>
                </div>
            </y-slide>
        </y-slideshow>
    </div>
</template>

<script>
    import { YSlide, YSlideshow } from '@groot-components/all';

    export default {
        name      : 'Advantages',
        components: { YSlide, YSlideshow },
        props     : {
            content         : Object,
            slideshowOptions: Object,
        },

        /**
         *
         * @inheritDoc
         */
        data() {
            return {
                options: {
                    breakpoints: {
                        992: {
                            slidesPerView: 2.9,
                            spaceBetween : 30,
                        },

                        0: {
                            slidesPerView: 1.2,
                            spaceBetween : 20,
                        },
                    },
                },

            };
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
